module.exports = {"short":"zh_hk","long":"Chinese (Traditional)","createdBy":"roger2hk"}


//////////////////
// WEBPACK FOOTER
// ./store/zh_hk/meta.json
// module id = I5cW
// module chunks = 1